import { expandValue } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppUser, AppUserCredential, AppUserCredentialView } from 'pbts/c1/api/app/v1/app_user'
import { Any } from 'pbts/google/protobuf/any'

export interface AppUserCredentialValue extends AppUserCredential {
    app?: App
    appUser?: AppUser
    vaultId?: string
}

export const expandAppUserCredentialView = (msg: AppUserCredentialView | undefined, values: Any[]): AppUserCredentialValue => {
    const u: AppUserCredentialValue = AppUserCredential.create(msg?.appUserCredential ?? {})
    u.app = expandValue<App>(msg?.appPath || '', App, values)
    u.appUser = expandValue<AppUser>(msg?.appUserPath || '', AppUser, values)
    return u
}
